import React from 'react';
import { Formik, Form } from 'formik';

import { SR_API_ACTION_UTILITY_LOGONAS } from 'api/utilityActionTypes';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import useDispatch from 'client/hooks/useDispatch';
import useApiState from 'client/hooks/useApiState';
import UtilityAuthActions from 'client/actions/UtilityAuth';

import SrBox from 'client/components/SrBox';
import SrErrorMessage from 'client/components/SrErrorMessage/SrErrorMessage';

import SrButton, { SR_BUTTON_THEME_ADOBE_GREEN } from 'client/components/SrButton/SrButton';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';

const formFields = [
  {
    id: 'phone',
    type: 'phone',
    validations: ['required', 'phone'],
    properties: {
      placeholder: 'Write phone here...',
    },
  },
];

const UPLoginAsForm = () => {
  const logonasApiState = useApiState(SR_API_ACTION_UTILITY_LOGONAS);

  const dispatch = useDispatch();
  const onSubmit = ({ phone }) => {
    dispatch(UtilityAuthActions.logonas, {
      phone,
    });
  };

  return (
    <Formik
      initialValues={createInitialValues({ formFields })}
      validate={createFormValidationFn(formFields)}
      onSubmit={onSubmit}
      enableReinitialize
      render={(formikBag) => (
        <Form>
          {formFields.map((formField) => (
            <SrFormikField
              key={formField.id}
              formField={formField}
              formikBag={formikBag}
              className={SR_FIELD_THEME_ADOBE}
            />
          ))}
          <SrBox marginTop="20px">
            <SrButton
              type="submit"
              theme={SR_BUTTON_THEME_ADOBE_GREEN}
              disabled={logonasApiState.inProgress}
            >
              Login As
            </SrButton>
          </SrBox>
          {logonasApiState.error && (
            <SrErrorMessage>{String(logonasApiState.error)}</SrErrorMessage>
          )}
        </Form>
      )}
    />
  );
};

UPLoginAsForm.displayName = 'UPLoginAsForm';

export default UPLoginAsForm;
